var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 159,
    height: 146,
    viewBox: "0 0 159 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.5331 71.776H66.6891V85.096C62.9891 79.028 51.0011 71.628 37.6811 71.628C17.4051 71.628 0.681061 88.352 0.681061 108.48C0.681061 128.608 17.4051 145.48 37.6811 145.48C51.0011 145.48 62.9891 137.932 66.6891 131.864V145.48H74.5331V71.776ZM37.6811 137.636C21.4011 137.636 8.52506 124.76 8.52506 108.48C8.52506 92.348 21.4011 79.472 37.6811 79.472C53.8131 79.472 66.6891 92.348 66.6891 108.48C66.6891 124.76 53.8131 137.636 37.6811 137.636ZM131.814 69.112V0.587994H123.97V69.112H97.6257V76.956H123.97V145.48H131.814V76.956H158.158V69.112H131.814Z",
    fill: "#FEC736"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAt);
export default __webpack_public_path__ + "static/media/AT.eeb91167508032e763cc9da3f3c10743.svg";
export { ForwardRef as ReactComponent };